import { omitBy } from 'lodash';
import { UserMetricsResponse } from '~/clientApi/metrics';

import { METRICS_INTERCOM_NAMES } from './IntercomContext.constants';
import * as viewModel from './IntercomContext.vm';

export const mapMetricsFromApiToVm = ({
  userId,
  userEmail,
  user_hash,
  userName,
  isManagerUser,
  isCreatorUser,
  isEchoUser,
  isCreatorManaged,
  agencyId,
  agencyName,
  agencyRole,
  echoWebStatus,
  agencyType,
  registered,
}: UserMetricsResponse['metrics']): viewModel.UserMetrics => {
  const mapped = {
    [METRICS_INTERCOM_NAMES.userId]: userId,
    [METRICS_INTERCOM_NAMES.userEmail]: userEmail,
    [METRICS_INTERCOM_NAMES.userHash]: user_hash,
    [METRICS_INTERCOM_NAMES.name]: userName,
    [METRICS_INTERCOM_NAMES.isManagerUser]: isManagerUser,
    [METRICS_INTERCOM_NAMES.isCreatorUser]: isCreatorUser,
    [METRICS_INTERCOM_NAMES.isCreatorManaged]: isCreatorManaged,
    [METRICS_INTERCOM_NAMES.isEchoUser]: isEchoUser,
    [METRICS_INTERCOM_NAMES.agencyId]: agencyId,
    [METRICS_INTERCOM_NAMES.agencyName]: agencyName,
    [METRICS_INTERCOM_NAMES.agencyRole]: agencyRole,
    [METRICS_INTERCOM_NAMES.agencyType]: agencyType,
    [METRICS_INTERCOM_NAMES.echoWebStatus]: echoWebStatus,
    [METRICS_INTERCOM_NAMES.registered]: registered,
  };

  // Filter out null values
  return omitBy(mapped, (value) => value === null) as viewModel.UserMetrics;
};
